import { c as _c } from "react/compiler-runtime";
import { OutOfDateMessage } from '@cc-shopping/ui/composites/OutOfDateMessage';
import { uniqBy } from '@cc-shopping/utils/array/uniqBy';
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
export const COMPLIANCE_OK_FIELDS = ['name', 'product.name', 'institution.name', 'product.institution.name', 'details.seo_name', 'derived_details.reward_cents_per_unit_string'];
export default function OutOfDateMessageBody() {
  const $ = _c(5);
  const {
    mentionedMarketplaceEntities
  } = useReviewContext();
  let t0;
  let t1;
  if ($[0] !== mentionedMarketplaceEntities) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const complianceInactiveEntities = mentionedMarketplaceEntities.filter(_temp);
      if (!complianceInactiveEntities.length) {
        t1 = null;
        break bb0;
      }
      const dedupedComplianceInactiveEntities = uniqBy(complianceInactiveEntities, _temp2);
      t0 = dedupedComplianceInactiveEntities.map(_temp3);
    }
    $[0] = mentionedMarketplaceEntities;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  const nameList = t0;
  let t2;
  if ($[3] !== nameList) {
    t2 = <Grid container={true} marginTop={2} marginBottom={5}><Grid size={12}><OutOfDateMessage inactiveEntities={nameList} /></Grid></Grid>;
    $[3] = nameList;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp3(entity_1) {
  return entity_1.displayName;
}
function _temp2(entity_0) {
  return entity_0.id;
}
function _temp(entity) {
  return !entity.isActive && !COMPLIANCE_OK_FIELDS.includes(entity.field);
}